import { IFormFieldValue } from '../../../../mf-my-home/types/formFields';
import { sortRuleRoomsCount } from '../../../../mf-my-home/constants/roomsCount';

export function sortRoomsCount(rawValues: IFormFieldValue<string | number>[]): IFormFieldValue<string | number>[] {
  return rawValues.sort(
    (a, b) => sortRuleRoomsCount.indexOf(a.value as number) - sortRuleRoomsCount.indexOf(b.value as number),
  );
}
